import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

function Title(props) {
  return (
    <Typography
      component="h5"
      variant="h4"
      color="primary"
      gutterBottom={true}
    >
      {props.children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
